module.exports = __webpack_public_path__ + "img/googleplay.e3b8a7ac.png";